import React from 'react';
import { IconSearch } from '@treatwell/ui';
import styles from './CollapsedContainer.module.css';

interface Props {
  mainLabel: string;
  secondLineLabelLeft: string;
  secondLineLabelRight: string;
  collapse: (collapsed: boolean) => void;
}

export class CollapsedContainer extends React.PureComponent<Props> {
  public render(): React.ReactNode {
    return (
      <div
        className={styles.container}
        onClick={() => this.props.collapse(false)}
      >
        <div className={styles.searchIcon}>
          <IconSearch size={24} />
        </div>
        <div className={styles.labelContainer}>
          <div className={styles.mainLabel}>{this.props.mainLabel}</div>
          <div className={styles.secondLine}>
            <div className={styles.secondLineLabelLeft}>
              {this.props.secondLineLabelLeft}
            </div>
            <div className={styles.separator}>・</div>
            <div className={styles.secondLineLabelRight}>
              {this.props.secondLineLabelRight}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
